import { tss } from 'tss-react/mui';
import {
    Checkbox,
    ListItemText,
    MenuItem,
    TextField,
    Autocomplete,
} from '@mui/material';
import type { AutocompleteProps } from '@mui/material';
import { getThemeColor } from '../../muiTheme';
import type {
    SelectOption,
    SelectOptions,
} from './useSelectWithCheckboxesProps.ts';

const useSelectWithCheckboxesStyles = tss
    .withNestedSelectors<'root'>()
    .create(({ theme, classes }) => ({
        root: {},
        label_options: {
            '& + span': {
                marginLeft: 24,
                color: getThemeColor(theme)('gray'),
                fontSize: 12,
            },
            // Hide response-count inside chips. Might be better to do a JS solution (why render something we should hide)
            [`.${classes.root} & + span`]: {
                display: 'none',
            },
        },
    }));

export default function SelectWithCheckboxes({
    options,
    values,
    onChange,
    label,
}: {
    options: SelectOptions;
    values: Array<string>;
    onChange: AutocompleteProps<string, true, false, false>['onChange'];
    label: string;
    color?: string;
    onDeleteValue: (option: SelectOption) => void;
}) {
    const { classes } = useSelectWithCheckboxesStyles();

    return (
        <Autocomplete
            multiple
            renderInput={(params) => (
                <TextField {...params} label={label} margin="normal" />
            )}
            disableCloseOnSelect={options.length > 2}
            options={options}
            value={options.filter((option) => values.includes(option.value))}
            onChange={(event, value, reason, details) => {
                onChange(
                    event,
                    value.map((value) => value.value),
                    reason,
                    {
                        option: details.option.value,
                    },
                );
            }}
            getOptionLabel={(option) => option.label}
            getOptionKey={(option) => option.value}
            ChipProps={{
                color: 'primary',
            }}
            renderOption={({ key, ...props }, option, state, _ownerState) => (
                <MenuItem key={key} {...props}>
                    <Checkbox checked={state.selected} />
                    <ListItemText
                        primary={
                            <span className={classes.label_options}>
                                {option.label}
                            </span>
                        }
                    />
                </MenuItem>
            )}
        />
    );
}
